import { render, staticRenderFns } from "./CoursewareReviewDetails.vue?vue&type=template&id=acd849fa&scoped=true"
import script from "./CoursewareReviewDetails.vue?vue&type=script&lang=js"
export * from "./CoursewareReviewDetails.vue?vue&type=script&lang=js"
import style0 from "./CoursewareReviewDetails.vue?vue&type=style&index=0&id=acd849fa&prod&lang=less"
import style1 from "./CoursewareReviewDetails.vue?vue&type=style&index=1&id=acd849fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd849fa",
  null
  
)

export default component.exports